<footer class="page-footer">
  <div [ngClass]="{'container-fluid': fullWidthView$ | async, 'container': !(fullWidthView$ | async)}">
    <div class="d-flex flex-wrap row  align-items-center justify-content-center">
      <div class="col-12 justify-content-center align-items-center credits">
        <span class="credits_company" *ngIf="tenantName$ | async">
          &#169; {{ tenantName$ | async }} 2019
        </span>
        <span class="credits_company" *ngIf="!(tenantName$ | async)">
          &#169; OrderField 2019
        </span>
        <span class="credits_divider">|</span>
        <span class="credits_poweredby">
          <a href="mailto:info@orderfield.com">Powered by OrderField</a>
        </span>
        <div *ngIf="hasImpressumLink" style="display: inline-block;">
          <span class="credits_divider">|</span>
          <span class="credits_link">
            <a href="{{ impressumLink }}" target="_blank">{{ 'footer.impressum' | translate }}</a>
          </span>
        </div>
        <div *ngIf="hasDatenSchutzLink" style="display: inline-block;">
          <span class="credits_divider">|</span>
          <span class="credits_link">
            <a href="{{ datenSchutzLink }}" target="_blank">{{ 'footer.datenschutz' | translate }}</a>
          </span>
        </div>
      </div>
    </div>
  </div>
</footer>
